import { Box, SxProps, Theme, Typography } from "@mui/material";

const InfoElem: React.FC<{ label: string, value: any, sx?: SxProps<Theme> }> = ({ label, value, sx }) => <Box sx={{ mb: 2, ...(sx || {}) }}>
  <Typography variant="body2">{label}:</Typography>
  <Typography variant="body1" color="initial">{value}</Typography>
</Box>;

export default InfoElem;